import { FieldLabel, Select, TextInput } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';
import { PassthroughNote } from '../shared/PassthroughNote.jsx';

export function FuzzyInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Right dataset</FieldLabel>
      <TextInput mono value={c.right} onChange={(v) => u({ right: v })} placeholder="vendor_master.csv" />
      <FieldLabel>Match left column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Against right column</FieldLabel>
      <TextInput mono value={c.rightCol} onChange={(v) => u({ rightCol: v })} placeholder="vendor_name" />
      <FieldLabel>Algorithm</FieldLabel>
      <Select value={c.algo || 'jaro_winkler'} onChange={(v) => u({ algo: v })}
        options={[
          { value: 'jaro_winkler', label: 'Jaro-Winkler' },
          { value: 'levenshtein', label: 'Levenshtein' },
          { value: 'soundex', label: 'Soundex' },
          { value: 'ngram', label: 'N-gram cosine' },
        ]} />
      <FieldLabel>Similarity threshold</FieldLabel>
      <TextInput mono type="number" value={c.threshold ?? 0.85}
        onChange={(v) => u({ threshold: Number(v) })} />
      <PassthroughNote what="fuzzy match" />
    </div>
  );
}
